import categorieSymbols from "../symbols/categories";
import { HttpRegularPost, HttpRequestPost } from "../../service";
const categoriesSymbolsAction = () => ({
  type: categorieSymbols.GET_CATEGORIES,
});
const categoriesSymbolsSuccessAction = (data: any) => ({
  type: categorieSymbols.GET_CATEGORIES_SUCCESS,
  payload: data,
});
const categoriesSymbolsFailureAction = (data: any) => ({
  type: categorieSymbols.GET_CATEGORIES_FAILURE,
  payload: data,
});
const clearCategoryDetailsSymbolsAction = () => ({
  type: categorieSymbols.CLEAR_GET_CATEGORIES,
});
const addCategoriesSymbolsSuccessAction = () => ({
  type: categorieSymbols.ADD_CATEGORY_SUCCESS,
});
export function getCategoriesSymbols() {
  return (dispatch: any) => {
    dispatch(categoriesSymbolsAction());
    HttpRequestPost(
      "/upc/category/list",
      dispatch,
      categoriesSymbolsSuccessAction,
      categoriesSymbolsFailureAction,
      true,
      { Query: "", OrderBy: "Asc" }
    );
  };
}

export function clearCategorysSymbols() {
  return (dispatch: any) => {
    dispatch(clearCategoryDetailsSymbolsAction());
  };
}

export function getCategoriesSymbolsWithParams(
  Query: string | null,
  OrderBy?: string | null,
  Filter?: any
) {
  return (dispatch: any) => {
    dispatch(categoriesSymbolsAction());
    HttpRequestPost(
      `/upc/category/list`,
      dispatch,
      categoriesSymbolsSuccessAction,
      categoriesSymbolsFailureAction,
      true,
      Filter ? { OrderBy, Query, Filter } : { OrderBy, Query }
    );
  };
}

export function addNewCategory(body: any, failAction?: any, callback?: (resp?: any) => void) {
  return (dispatch: any) => {
    HttpRegularPost("/upc/category", body, {
      dispatch: dispatch,
      actionSuccess: addCategoriesSymbolsSuccessAction,
      actionFailure: failAction,
      callback
    });
  };
}
